import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserServiceImpl } from 'src/app/user/service/user.service';
import { MatDialog } from '@angular/material/dialog';
import { VehiculeModalComponent } from '../vehicule-modal/vehicule-modal.component';
import { Vehicule } from 'src/app/user/user.model';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { languageSelector, organisationSelector } from 'src/app/global/store/global.selectors';
import { userRecordSelector } from 'src/app/user/store/user.selectors';

@Component({
    selector: 'app-user-vehicle',
    templateUrl: './user-vehicle.component.html',
    styleUrls: ['./user-vehicle.component.scss'],
})
export class UserVehicleComponent implements OnInit, OnDestroy {
    nowLoading: boolean;
    private destroy$ = new Subject();
    vehicleslist: Vehicule[] = [];
    editVehicule: Vehicule = {
        make: '',
        model: '',
        plate: '',
    };
    constructor(
        public dialog: MatDialog,
        public store: Store<State>,
        private translate: TranslateService,
        public userService: UserServiceImpl,
    ) {}

    ngOnInit(): void {
        this.nowLoading = true;

        this.store
            .select(languageSelector)
            .pipe(
                takeUntil(this.destroy$),
                take(1),
                tap((lang) => {
                    this.translate.use(lang);
                }),
            )
            .subscribe();
        this.store
            .select(organisationSelector)
            .pipe(
                takeUntil(this.destroy$),
                filter((profile) => !!profile),
                tap((profile) => {
                    this.userService.organisation = profile.tag;
                }),
            )
            .subscribe();

        this.store
            .select(userRecordSelector)
            .pipe(
                takeUntil(this.destroy$),
                filter((profile) => !!profile),
                tap((profile) => {
                    this.userService.user = profile.id;
                    this.userService
                        .getUserVehicules()
                        .pipe(
                            takeUntil(this.destroy$),
                            tap((vehicles) => {
                                this.vehicleslist = vehicles;
                            }),
                        )
                        .subscribe();
                }),
                tap(() => {
                    this.nowLoading = false;
                }),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    openCreate() {
        const ref = this.dialog.open(VehiculeModalComponent, {
            data: { value: 3 },
        });
        ref.afterClosed().subscribe((result) => {
            if (result.event === 'Save') {
                const newCar = {
                    model: result.data.model,
                    year: result.data.year,
                    make: result.data.make,
                    plate: result.data.plate,
                    order: Object.keys(this.vehicleslist).length,
                    favorite: 0,
                };
                this.vehicleslist = [...this.vehicleslist, newCar];
                this.userService.addUserVehicule(newCar);
            }
        });
    }
}
